interface setEventProps extends Event {
  key?: string;
  newValue?: string;
}

const dispatchEventStorage = () => {
  // 重写setItem事件，当使用setItem的时候，触发，window.dispatchEvent派发事件
  const signSetItem = localStorage.setItem;
  localStorage.setItem = function (key, val) {
    const setEvent: setEventProps = new Event('setStorageItemEvent');
    setEvent.key = key;
    setEvent.newValue = val;
    window.dispatchEvent(setEvent);
    signSetItem.apply(this, arguments);
  };
};

export { dispatchEventStorage };
